import React from 'react'
import { shallow } from 'enzyme'
import SubNav from '../SubNav'
import SubNavLink from '../SubNavLink'

describe('<SubNav />', () => {
  let props
  beforeEach(() => {
    props = {
      leftLink: {
        title: 'hello',
        href: 'world'
      },
      rightLink: {
        title: 'whats up'
      }
    }
  })
  it('should return something', () => {
    expect(SubNav(props)).toBeTruthy()
  })
  it('should render two <SubNavLinks />', () => {
    const wrapper = shallow(<SubNav {...props} />)
    expect(wrapper.find(SubNavLink)).toHaveLength(2)
  })
})
